/**
 * Replaces placeholders in a translation string with provided values.
 *
 * @param {string} translation - The translation string with placeholders.
 * @param {Record<string, string>} params - The values to replace the placeholders.
 * @return {string} The translated string with placeholders replaced.
 */
const t = (translation: string, params: Record<string, string>): string =>
  Object.entries(params).reduce(
    (str, [key, value]) => str.replace(`{{${key}}}`, value),
    translation
  );

export default t;
